/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cd_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The seconds update live, every second.`)
};

const es_cd_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los segundos se actualizan en vivo, cada segundo.`)
};

const de_cd_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Sekunden werden live, jede Sekunde, aktualisiert.`)
};

const nl_cd_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De seconden worden live bijgewerkt, elke seconde.`)
};

const fr_cd_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les secondes se mettent à jour en direct, chaque seconde.`)
};

const it_cd_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I secondi si aggiornano dal vivo, ogni secondo.`)
};

const pt_br2_cd_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os segundos são atualizados ao vivo, a cada segundo.`)
};

const pt_cd_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os segundos atualizam-se ao vivo, a cada segundo.`)
};

const ja_cd_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`秒数は1秒ごとにリアルタイムで更新されます。`)
};

const zh_cd_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`秒数每秒实时更新。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cd_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cd_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cd_ex3", locale)
	if (locale === "en") return en_cd_ex3(inputs)
	if (locale === "es") return es_cd_ex3(inputs)
	if (locale === "de") return de_cd_ex3(inputs)
	if (locale === "nl") return nl_cd_ex3(inputs)
	if (locale === "fr") return fr_cd_ex3(inputs)
	if (locale === "it") return it_cd_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_cd_ex3(inputs)
	if (locale === "pt") return pt_cd_ex3(inputs)
	if (locale === "ja") return ja_cd_ex3(inputs)
	return zh_cd_ex3(inputs)
};